import { createStore } from 'vuex'

export default createStore({
  state: {
    services: [
      { 
        id: 1, 
        name: 'No-Code', 
        nameEn: 'No-Code',
        color: 'service-gradient-1', 
        description: 'Développez rapidement sans coder',
        descriptionEn: 'Fast-track development, zero coding'
      },
      { 
        id: 2, 
        name: 'SEO', 
        nameEn: 'SEO',
        color: 'service-gradient-2', 
        description: 'Optimisation pour les moteurs de recherche',
        descriptionEn: 'Search engine optimization'
      },
      { 
        id: 3, 
        name: 'SaaS', 
        nameEn: 'SaaS',
        color: 'service-gradient-3', 
        description: 'Logiciel en tant que service',
        descriptionEn: 'Software as a Service'
      },
      { 
        id: 4, 
        name: 'Chatbots', 
        nameEn: 'Chatbots',
        color: 'service-gradient-4', 
        description: 'Assistants conversationnels',
        descriptionEn: 'Conversational assistants'
      },
      { 
        id: 5, 
        name: 'Data Science', 
        nameEn: 'Data Science',
        color: 'service-gradient-5', 
        description: 'Analyse et visualisation de données',
        descriptionEn: 'Data analysis and visualization'
      }
    ]
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})